import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { LocationLicenseOverviewKeys } from "modules/LocationLicenseOverview/queryKeys";
import { ApiInstance } from "utils/Api";

export type DeleteStandaloneLicencePayload = {
  standalone_license_id: number;
};

export const useSelectedStandaloneLicenceDeleteMutation = () =>
  useTypedMutation<DeleteStandaloneLicencePayload, void>({
    mutationFn: async payload => (await ApiInstance.post("/licenses/standalone/delete", payload, ENV.exactBaseURL)).data,
    onSuccess: ({ standalone_license_id }) => {
      const licenses = typedQueryClient.getQueryData(LocationLicenseOverviewKeys.licenses);
      if (!licenses) return;

      const standaloneLicenseIdx = licenses.standalone_licenses?.findIndex(license => license.id === standalone_license_id) ?? -1;
      if (standaloneLicenseIdx === -1) return;

      typedQueryClient.setQueryData(LocationLicenseOverviewKeys.licenses, {
        ...licenses,
        standalone_licenses: licenses.standalone_licenses?.toSpliced(standaloneLicenseIdx, 1)
      });
    }
  });
